/** Popper modifier config - typed so modifiers array is mutable for MUI compatibility */
type PopperModifier = {
  name: string;
  options?: Record<string, unknown>;
};

/**
 * Shared Popper.js modifiers for inline dropdown / multiselect poppers.
 * Uses fixed positioning + viewport boundary so lists are not clipped by the
 * table scroll container when the column sits at the viewport edge (DL-60609).
 */
export const INLINE_POPPER_MODIFIERS: PopperModifier[] = [
  {
    name: 'flip',
    options: {
      fallbackPlacements: ['bottom-end', 'top-start', 'top-end', 'bottom-start'],
    },
  },
  {
    name: 'preventOverflow',
    options: {
      boundary: 'viewport',
      rootBoundary: 'viewport',
      altAxis: true,
      mainAxis: true,
      tether: false,
      padding: 8,
    },
  },
  {
    name: 'eventListeners',
    options: {
      scroll: true,
      resize: true,
    },
  },
];

export const INLINE_POPPER_OPTIONS = {
  strategy: 'fixed' as const,
  modifiers: INLINE_POPPER_MODIFIERS,
};
